
/**
 * Hook global functions here
 * e.g. window.lockacademyInitialize.push(function(){ ... });
 * They will be launched respectively :
 * - Imediately after a new page is loaded
 * - When the transition ends 
 */

 window.Polyglot = require('node-polyglot');

require('normalize.css');
require('../scss/app.scss');

require('./menu.js');
require('./mobile-menu.js');
require('./accordion.js');
require('./social-share.js');
require('./login-modal.js');
require('./select2.js');
require('./map.js');